import { yupResolver } from "@hookform/resolvers/yup";
import { useSnackbar } from "notistack";
import { useForm } from "react-hook-form";

import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import ControlledTextFieldSeparatedLabel from "../../../../components/controlled/ControlledTextFieldSeparatedLabel/index.jsx";

import { Button } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAdminUpdateTimocomIntegrationMutation } from "../../integrationsApiSlice.js";
import { getFormSchema } from "./formSchema.js";

const TimocomForm = ({
	companyId,
	status,
	timocomCustomerRef,
	timocomPrincipalName,
	timocomPassword,
}) => {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const [updateTimocomIntegration, { isLoading }] =
		useAdminUpdateTimocomIntegrationMutation();

	const formSchema = getFormSchema(t);
	const {
		handleSubmit,
		control,
		formState: { errors },
		setValue,
		setError,
	} = useForm({
		defaultValues: {},
		resolver: yupResolver(formSchema),
		shouldFocusError: true,
	});

	useEffect(() => {
		if (timocomCustomerRef) {
			setTimeout(() => {
				setValue("timocomCustomerRef", timocomCustomerRef);
			}, 200);
		}
		if (timocomPrincipalName) {
			setTimeout(() => {
				setValue("timocomPrincipalName", timocomPrincipalName);
			}, 200);
		}
		if (timocomPassword) {
			setTimeout(() => {
				setValue("timocomPassword", timocomPassword);
			}, 200);
		}
	}, [timocomCustomerRef, timocomPrincipalName, timocomPassword, setValue]);

	const onSubmit = async ({
		timocomCustomerRef,
		timocomPrincipalName,
		timocomPassword,
	}) => {
		await updateTimocomIntegration({
			companyId,
			timocomCustomerRef,
			timocomPrincipalName,
			timocomPassword,
		})
			.unwrap()
			.then((_payload) => {
				enqueueSnackbar(t("updated_client_timo_integration"), {
					variant: "success",
				});
			})
			.catch((error) => {
				if (error?.data?.errors) {
					const errors = error.data.errors;
					Object.entries(errors).forEach(([key, message]) => {
						setError(key);
						enqueueSnackbar(message[0], {
							variant: "error",
							preventDuplicate: true,
						});
					});
				} else {
					enqueueSnackbar(error?.data?.message || t("default_error"), {
						variant: "error",
						preventDuplicate: true,
					});
				}
			});
	};

	useEffect(() => {
		if (Object.keys(errors).length > 0) {
			Object.values(errors).forEach((err) => {
				if (err.message) {
					enqueueSnackbar(err.message, {
						variant: "error",
						preventDuplicate: true,
					});
				}
			});
		}
	}, [errors, enqueueSnackbar]);

	return (
		<Box
			component="form"
			autoComplete="off"
			noValidate
			onSubmit={handleSubmit(onSubmit)}
			sx={{ p: 0 }}
		>
			<Grid container spacing={5}>
				<Grid size={6}>
					<Grid container spacing={2}>
						<Grid size={12}>
							<Box
								sx={{
									display: "flex",
									alignItems: "center",
									gap: "6px",
								}}
							>
								<Typography sx={{ fontWeight: 600 }}>
									{t("status")}:{" "}
								</Typography>
								{status ? (
									<Chip label={t("integrated")} color="success" />
								) : (
									<Chip label={t("no_integration")} color="secondary" />
								)}
							</Box>
						</Grid>
						<Grid size={12}>
							<ControlledTextFieldSeparatedLabel
								control={control}
								name="timocomCustomerRef"
								type="text"
								label="Customer ref (TC ID)"
								error={!!errors?.timocomCustomerRef}
								labelXs={6}
								fieldXs={6}
								autoComplete="off timocomCustomerRef new-password"
								inputProps={{
									autoComplete: "off timocomCustomerRef new-password",
								}}
							/>
						</Grid>
						<Grid size={12}>
							<ControlledTextFieldSeparatedLabel
								control={control}
								name="timocomPrincipalName"
								type="password"
								label="Principal name"
								error={!!errors?.timocomPrincipalName}
								labelXs={6}
								fieldXs={6}
								autoComplete="off timocomPrincipalName new-password"
								inputProps={{
									autoComplete: "off timocomPrincipalName new-password",
								}}
							/>
						</Grid>
						<Grid size={12}>
							<ControlledTextFieldSeparatedLabel
								control={control}
								name="timocomPassword"
								type="password"
								label="TC password"
								error={!!errors?.timocomPassword}
								labelXs={6}
								fieldXs={6}
								autoComplete="off timocomPassword new-password"
								inputProps={{
									autoComplete: "off timocomPassword new-password",
								}}
							/>
						</Grid>
						<Grid size={12}>
							<Box sx={{ display: "flex", justifyContent: "end" }}>
								<Button loading={isLoading} type="submit" variant="contained">
									{t("save")}
								</Button>
							</Box>
						</Grid>
					</Grid>
				</Grid>
				<Grid size={6}>{/* INFO HERE */}</Grid>
			</Grid>
		</Box>
	);
};

export default TimocomForm;
